module.exports = __webpack_public_path__ + "img/ic-delete.25de1802.svg";